import { RoadDetailInfo as L2RSegmentDetailInfo } from "@l2r-front/l2r-networks"
import { styled, styledForMobile } from "@l2r-front/l2r-ui"

import { VerticalSignsGrading as L2RVerticalSignsGrading } from "../../containers/VerticalSignsGrading"
import { VerticalSignTypeList as L2RVerticalSignTypeList } from "../../containers/VerticalSignTypeList"

export const VerticalSignsGrading = styledForMobile(L2RVerticalSignsGrading, ["road"])(({ isMobile, road, theme }) => ({
    padding: isMobile ? theme.spacing(0, 6, 5, 6) : theme.spacing(road ? 0 : 5, 0, 0, 0),
}))

export const VerticalSignTypeList = styledForMobile(L2RVerticalSignTypeList)(({ isMobile, theme }) => ({
    padding: isMobile ? theme.spacing(0, 6, 0, 6) : theme.spacing(8, 0),
}))

export const RoadDetailInfo = styledForMobile(L2RSegmentDetailInfo)(({ isMobile, theme }) => ({
    padding: isMobile ? theme.spacing(0, 6, 0, 6) : theme.spacing(5, 0, 0, 0),
    marginBottom: theme.spacing(isMobile ? 6 : 5),
}))

export const Container = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
}))